import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { changeWallet } from "../../App/Slices/userSlice";
import { RootState } from "../../App/store";
import ContractService from "../../Services/ContractService";
import ToastService from "../../Services/ToastService";
import UtilsService from "../../Services/UtilsService";
import "./ConnectWallet.scss";
import { ConnectorType } from "../../Services/BchConnectorTypes";
import { openPopup, closePopup } from "../../App/Slices/popupSlice";
import BchConnectorService from "../../Services/BchConnectorService";

export const ConnectWallet = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const userSelector = useSelector((state: RootState) => state.user);

  const dispatch = useDispatch();

  const connectBchConnector = useCallback(async (connectorType: ConnectorType) => {
    closeModal();

    localStorage.setItem("connectedOnce", connectorType as any);
    setLoading(true);
    let successConnection = true;

    try {
      BchConnectorService.setConnector(connectorType);
      let cashaddr = await BchConnectorService.sendConnectionRequest().catch(
        (e) => console.log("sendConnectionRequest error :", e)
      );

      dispatch(changeWallet(cashaddr!));
      successConnection = true;
    } catch (error) {
      console.log(error)
      setLoading(false);
      successConnection = false;
      ToastService.error(BchConnectorService.handleErrorMessage(error));
      localStorage.removeItem("connectedOnce");
    }

    setLoading(false);

    if (!successConnection) return;
  }, []);

  const checkPluginAndConnect = useCallback(async (connectorType: ConnectorType | "Metamask") => {
    if (connectorType === "Paytaca" && !window.paytaca) {
      ToastService.error("Please install Paytaca browser extension");
      return;
    }

    if (connectorType === "Metamask" && !(window as any).ethereum) {
      ToastService.error("Please install Metamask browser extension");
      return;
    }

    if (connectorType === "Metamask") {
      await connectMetamask();
    } else {
      await connectBchConnector(connectorType as ConnectorType);
    }
  }, []);

  const connectMetamask = useCallback(async () => {
    closeModal();
    setLoading(true);
    localStorage.setItem("connectedOnce", "Metamask");
    let successConnection = true;

    try {
      const connectionRes = await ContractService.sendConnectionRequest().catch(
        (e) => console.log("sendConnectionRequest error :", e)
      );
      dispatch(changeWallet(connectionRes[0]));
    } catch (error) {
      setLoading(false);
      successConnection = false;
      ToastService.error(ContractService.handleErrorMessage(error));
      localStorage.removeItem("connectedOnce");
    }

    await ContractService.setUpContract().catch(() => {
      setLoading(false);
      successConnection = false;
      return;
    });

    if (!successConnection) return;

    try {
      const userAddress = await ContractService.getSigner().getAddress();

      if (!userAddress) return;
      dispatch(changeWallet(userAddress));

      // if (localStorage.getItem('spicaToken')) {
      //   let userRes = await this.authService.getUser();
      //   userRes['token'] = localStorage.getItem('spicaToken');
      //   //nex to subject
      //   this.user = userRes;
      // }

      setLoading(false);
    } catch (err: any) {
      setLoading(false);
      ToastService.error(ContractService.handleErrorMessage(err));
    }
  }, []);

  // const connectMetamask = async () => {
  //   setLoading(true);
  //   localStorage.setItem("connectedOnce", "true");
  //   let successConnection = true;
  //   try {
  //     const connectionRes = await ContractService.sendConnectionRequest();
  //     console.log("connectionRes :", connectionRes);
  //     //Remove  successConnection = false; line after contact coming
  //     successConnection = false;
  //     dispatch(changeWallet(connectionRes[0]));
  //   } catch (error) {
  //     console.log("error :", error);
  //     setLoading(false);
  //     successConnection = false;
  //     ToastService.error(ContractService.handleErrorMessage(error));
  //     localStorage.removeItem("connectedOnce");
  //   }
  //   // WILL OPEN AFTER CONTRACT COMING
  //   // await this.contractService.setUpContract().catch(() => {
  //   //   this.loading = false;
  //   //   successConnection = false;
  //   //   return;
  //   // });

  //   if (!successConnection) return;

  //   try {
  //     const userAddress = await ContractService.getSigner().getAddress();

  //     if (!userAddress) return;
  //     dispatch(changeWallet(userAddress));

  //     // if (localStorage.getItem('spicaToken')) {
  //     //   let userRes = await this.authService.getUser();
  //     //   userRes['token'] = localStorage.getItem('spicaToken');
  //     //   //nex to subject
  //     //   this.user = userRes;
  //     // }

  //     setLoading(false);
  //   } catch (err: any) {
  //     setLoading(false);
  //     ToastService.error(ContractService.handleErrorMessage(err));
  //   }
  // };

  useEffect(() => {
    const connectorType = localStorage.getItem("connectedOnce");
    if (connectorType === "Metamask") {
      connectMetamask();
    } else if (connectorType || 'null' !== 'null') {
      connectBchConnector(connectorType as any);
    }
  }, [connectBchConnector, connectMetamask]);

  const openModal = () => {
    dispatch(openPopup(walletSelectModal));
  };

  const closeModal = () => {
    dispatch(closePopup(0));
    setTimeout(() => {
      setLoading(false);
    }, 100);
  };

  const walletSelectModal = useMemo(
    () => (
      <div className="wallet-select-modal">
        <div>
          <h2>Select Wallet</h2>
        </div>

        <label>AVAX</label>
        <button onClick={() => checkPluginAndConnect("Metamask")}>Metamask</button>
        <label style={{marginTop: "2rem"}}>BCH</label>
        <button onClick={() => checkPluginAndConnect("Paytaca")}>Paytaca</button>
        <button style={{marginTop: "0.5rem"}} onClick={() => checkPluginAndConnect("WalletConnectV2")}>WalletConnect</button>
      </div>
    ),
    [loading, userSelector.user]
  );

  const disconnectWallet = useCallback(async () => {
    localStorage.removeItem("connectedOnce");
    await BchConnectorService.disconnect();
    dispatch(changeWallet(""));
  }, []);

  return (
    userSelector.wallet ? (
      <div className="ConnectWallet" onClick={disconnectWallet}>
        <span title={userSelector.wallet}>
          {UtilsService.shortenAddress(userSelector.wallet)}
          <span className="material-symbols-outlined">eject</span>
        </span>
      </div>
    ) : (
      <div className="ConnectWallet" onClick={openModal}>
        <span>
          <span className="material-symbols-outlined">add</span> Connect your
          wallet
        </span>
      </div>
    )
  );
};
export default ConnectWallet;
